import React from 'react';

class Resource extends React.Component {
  state = {
    mining: false,
  };

  clickHandler = (event) => {
    event.preventDefault();
    if (!this.state.mining && !this.props.empty) {
      const { data, redux } = this.props;
      this.setState({
        mining: true,
      });
      setTimeout(() => {
        this.setState({
          mining: false,
        });

        let minedResources = Math.round(
          data.baseResult + data.baseResult * (redux.drill.quality / 20)
        );

        let minedWeight = minedResources * data.weight,
          overweight = false,
          allowedWeight;

        if (
          redux.resources.weight.current + minedWeight >=
          redux.resources.weight.max
        ) {
          overweight = true;
          allowedWeight =
            minedWeight -
            (redux.resources.weight.current +
              minedWeight -
              redux.resources.weight.max);
        }

        if (overweight) {
          minedResources = Math.floor(allowedWeight / data.weight);
        }

        if (data.totalResources < minedResources) {
          minedResources = data.totalResources;
          data.totalResources = 0;
        } else {
          data.totalResources -= minedResources;
        }

        redux.addItemToInventoryAction({
          name: data.name,
          value: minedResources,
          weight: minedResources * data.weight,
          baseWeight: data.weight,
          basePrice: data.basePrice,
        });

        redux.updateWeightAction(minedResources * data.weight);

        redux.updateTerrainBlockAction(data);
      }, data.baseMiningTime - (data.baseMiningTime / 100) * redux.drill.speed + data.baseMiningTime / 100);
    }
  };

  onDrop = (event) => {
    event.preventDefault();
    let data = JSON.parse(event.dataTransfer.getData('text/plain'));
    console.log('onDrop', data, this.props);
    const { prevProps } = this.props;
    this.props.data.extracting = true;
    this.setState(data, () => {
      prevProps.energy = prevProps.energy - data.data.properties.energyRequired;
      --prevProps.inventory[data.name].value;
      this.props.callback(this.props.prevProps);
    });
  };

  onDragOver = (event) => {
    console.log('onDragOver');
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    console.log(this);
    if (this.props.prevProps.energy <= 0) {
      event.dataTransfer.dropEffect = 'none';
    }
  };
  /*

    <button
                className="coin__clicker"
                disabled={this.props.disabled}
                onClick={this.clickHandler}
            ><span className="coin__clicker-name">{data.name}</span><span className="icon icon-unit"></span> {Math.round(data.basePrice * data.baseResult * (1 + passProps.drill.quality/10) - 1)} <span className="coin__clicker-time"><span className="icon icon-time"/> {((data.baseMiningTime - passProps.drill.speed*100 + 100)/1000).toFixed(1)}</span><span className="coin__clicker-total">{data.totalResources} left</span></button>

     */
  render() {
    const { data, redux } = this.props;
    let style = {
      transitionDuration: this.state.mining
        ? data.baseMiningTime -
          (data.baseMiningTime / 100) * redux.drill.speed +
          data.baseMiningTime / 100 +
          'ms'
        : 'unset',
    };
    return (
      <div
        className={
          this.state.mining || this.props.empty
            ? 'terrain__block-resource mining'
            : 'terrain__block-resource'
        }
        onClick={this.clickHandler}
        onDrop={this.onDrop}
        onDragOver={this.onDragOver}
      >
        {data.name}
        <br />
        <p>
          {data.totalResources}u<br />
          <span className="icon icon-unit" /> {data.basePrice} | {data.weight}wu
          <br />
          {Math.round(
            data.baseResult + data.baseResult * (redux.drill.quality / 20)
          )}
          u/
          {(data.baseMiningTime -
            (data.baseMiningTime / 100) * redux.drill.speed +
            data.baseMiningTime / 100) /
            1000}
          s
        </p>
        <div
          className={
            this.state.mining
              ? 'terrain__block-resource-info mining'
              : 'terrain__block-resource-info'
          }
          style={style}
        ></div>
      </div>
    );
  }
}

export { Resource };
